/**
 * Short-window deduplication by key (a delivery id): the same click can reach the page through the
 * launch URL and a worker message, and the same message through two listeners. Pure and
 * in-memory: it protects the window, the event queue protects forever.
 */
const DEFAULT_WINDOW_MS = 30 * 1000;

export const createDedupe = (windowMs = DEFAULT_WINDOW_MS, now = Date.now) => {
  const seen = new Map();

  const sweep = () => {
    const limit = now() - windowMs;
    seen.forEach((at, key) => {
      if (at < limit) {
        seen.delete(key);
      }
    });
  };

  return {
    /** True the first time a key is seen inside the window. */
    first(key) {
      if (!key) {
        return true;
      }
      sweep();
      if (seen.has(key)) {
        return false;
      }
      seen.set(key, now());
      return true;
    },
    clear() {
      seen.clear();
    },
    size() {
      return seen.size;
    },
  };
};
